// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ViewUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as OrderEligibilityStatus from "../../../../../app/partner/entity/OrderEligibilityStatus.bs.js";

function getOrderEligibilityStatus(partner_record_data) {
  var partnerOnboardingData = ViewUtils$Catalyst.extractLiveData(partner_record_data.partnerOnboardingData);
  var partnerWaitlistData = ViewUtils$Catalyst.extractLiveData(partner_record_data.partnerWaitlistData);
  var suspensionData = ViewUtils$Catalyst.extractLiveData(partner_record_data.suspensionInfo);
  var terminationData = ViewUtils$Catalyst.extractLiveData(partner_record_data.terminationInfo);
  if (partnerOnboardingData !== undefined && partnerWaitlistData !== undefined && suspensionData !== undefined && terminationData !== undefined) {
    var match = partnerOnboardingData.onboarding_status;
    if (match < 2) {
      return /* YetToCompleteTraining */4;
    }
    var match$1 = terminationData.activeStatus;
    var match$2 = suspensionData.suspend_status;
    var match$3 = partnerWaitlistData.driver_uuid;
    if (match$1 !== 1) {
      if (match$2) {
        if (match$3 !== undefined) {
          return /* Waitlisted */1;
        } else {
          return /* ReadyForOrders */0;
        }
      } else {
        return /* Suspended */2;
      }
    } else {
      return /* Terminated */3;
    }
  } else {
    return /* NotAvailable */5;
  }
}

function getOrderEligibilityStatusView(partner_status) {
  var orderEligibilityStatusStr = OrderEligibilityStatus.toString(partner_status);
  switch (partner_status) {
    case /* ReadyForOrders */0 :
        return React.createElement("div", {
                    className: "u-padding-xs u-color-p-green-dark u-bg-color-p-green-light"
                  }, orderEligibilityStatusStr);
    case /* Waitlisted */1 :
        return React.createElement("div", {
                    className: "u-padding-xs u-color-p-blue-dark u-bg-color-p-blue-light"
                  }, orderEligibilityStatusStr);
    case /* Suspended */2 :
        return React.createElement("div", {
                    className: "u-padding-xs u-color-p-amber-dark u-bg-color-p-amber-light"
                  }, orderEligibilityStatusStr);
    case /* Terminated */3 :
        return React.createElement("div", {
                    className: "u-padding-xs u-color-p-red-dark u-bg-color-p-red-light"
                  }, orderEligibilityStatusStr);
    case /* YetToCompleteTraining */4 :
    case /* NotAvailable */5 :
        return React.createElement("div", {
                    className: "u-padding-xs u-color-p-grey-dark u-bg-color-p-grey-light"
                  }, orderEligibilityStatusStr);
    
  }
}

export {
  getOrderEligibilityStatus ,
  getOrderEligibilityStatusView ,
  
}
/* react Not a pure module */
